import React, { useEffect } from "react";
import { trackMatchInteraction } from "../../../../libraries/_modules/tracking/helpers";
import { statusTypes, useMatchData } from "../../utils";
import { StyledMatchCTA, StyledMatchHotelBookLabel } from "./StyledMatchWatch";
import { useReactAppState } from "../../../shared/containers/utils";
import { getHotelBookingIconUrl } from "../../../shared/utils";

function MatchHotelBook() {
    const { t } = useReactAppState();
    const { promoInfo, status, slug } = useMatchData();
    const { firstPartyTickets, thirdPartyTickets, hotelBooking } = promoInfo || {};
    const { url, openInNewTab, displayText, altText } = hotelBooking || {};

    const hotelBookingIconUrl = getHotelBookingIconUrl({ variant: "dark" });

    const trackInteraction = (event) => {
        if (!event) return null;
        event.preventDefault();
        const { href, target } = event.currentTarget;


        trackMatchInteraction({
            event: "cta_clicked",
            match: slug,
            cta_button_location: "schedule page",
            ctaAction: "book_hotel",
        });

        window.open(href, target);
    }

    useEffect(() => {
        if (url) {
            trackMatchInteraction({
                event: "cta_viewed",
                match: slug,
                cta_button_location: "schedule page",
                ctaAction: "book_hotel",
            });
        }
    }, [url, slug]);

    if (!hotelBooking || status?.abbreviation !== statusTypes.pre) {
        return null;
    }

    return (
        <a href={url} alt={altText || displayText} target={openInNewTab ? "_blank" : "_self"} rel="noopener noreferrer" onClick={(e) => trackInteraction(e)}>
            <StyledMatchCTA className="mls-c-match-list__match-cta">
                <StyledMatchHotelBookLabel className="mls-c-match-list__match-hotel-book-label">{t("hotels")}</StyledMatchHotelBookLabel>
                <img src={hotelBookingIconUrl} height={16} width={16} />
            </StyledMatchCTA>
        </a>
    );
}

export default MatchHotelBook;
